// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e4d44ca3","453":"6a6bfe51","667":"7e1622b3","977":"e3c04886"}[chunkId] + ".chunk.js";
};